// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Index_checkbox__xQNsP"};